import { VpCarouselMethods } from '@ps/bridge/qc/vp/carousel'
const VpCategories = {
  carousel: 'Carousel Component',
}
export default {
  carouselAction: {
    [VpCarouselMethods.vpCarouselComponentEnable]: {
      label: 'カルーセルコンポーネント有効化/無効化',
      category: VpCategories.carousel,
      paramFormConfig: {
        isEnable: {
          title: '有効化/無効化',
          component: 'select',
          field: {
            options: [
              {
                label: '有効化',
                value: true,
              },
              {
                label: '無効化',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpCarouselMethods.vpCarouselEnable]: {
      label: 'カルーセルグループ有効化/無効化',
      category: VpCategories.carousel,
      paramFormConfig: {
        carouselId: {
          title: '応答オブジェクト',
          component: 'select',
          field: {
            options: [],
          },
        },
        isEnable: {
          title: '有効化/無効化',
          component: 'select',
          field: {
            options: [
              {
                label: '有効化',
                value: true,
              },
              {
                label: '無効化',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpCarouselMethods.vpCarouselPause]: {
      label: 'カルーセルグループの一時停止/再生',
      category: VpCategories.carousel,
      paramFormConfig: {
        carouselId: {
          title: '応答オブジェクト',
          component: 'select',
          field: {
            options: [],
          },
        },
        isPause: {
          title: '一時停止/再生',
          component: 'select',
          field: {
            options: [
              {
                label: '一時停止',
                value: true,
              },
              {
                label: '再生する',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpCarouselMethods.vpCarouselRestart]: {
      label: 'カルーセルを再開する',
      category: VpCategories.carousel,
      paramFormConfig: {
        carouselId: {
          title: '応答オブジェクト',
          component: 'select',
          field: {
            options: [],
          },
        },
      },
    },
    [VpCarouselMethods.vpCarouselDeleteResource]: {
      label: 'カルーセルリソースの削除',
      category: VpCategories.carousel,
      paramFormConfig: {
        resourceIds: {
          title: '応答オブジェクト',
          component: 'select-group',
          field: {
            options: [],
          },
        },
      },
    },
    [VpCarouselMethods.vpCarouselSetStayTime]: {
      label: '滞在時間',
      category: VpCategories.carousel,
      paramFormConfig: {
        stayTime: {
          title: '滞在時間',
          component: 'input',
        },
      },
    },
  },
}
